import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private mUserService: UserService, private mRouter: Router) {

  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return new Observable(obsr => {
      this.mUserService.getUser().subscribe(r => {
        if (!r || r.role != this.mUserService.userRoles.Admin) {
          this.mRouter.navigate(['/login']);
        }

        obsr.next(!!r);
      });
    });

    /* const isExistUser = !!this.mUserService.getUser();

    if (!isExistUser) {
      this.mRouter.navigate(['/login']);
    }

    return isExistUser; */
  }

}
